// MUI components and icons
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

// Project hooks
import { useAppSelector } from "../../../../../services/StoreHelper";

// External libraries
import { BounceLoader } from "react-spinners";

interface ErrorDialogProps {
  open: boolean;
  onClose: () => void;
  error: string;
  contract: any;
}

export default function ErrorDialog({
  open,
  onClose,
  error,
  contract,
}: ErrorDialogProps) {
  const { cancel_process, club } = useAppSelector((state) => state.app);

  // 🔹 Toggle language here (can be lifted later)
  const { usesSpanish } = club;

  const titleText = contract.onlineCancelReview
    ? usesSpanish
      ? "Tu solicitud de cancelación todavía se está procesando."
      : "Your cancellation request is still processing."
    : usesSpanish
    ? "Error"
    : "Error";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          fontFamily: "'Montserrat', sans-serif",
          borderRadius: 2,
          padding: 3,
          width: 400,
          "& .MuiInputBase-inputMultiline": {
            padding: "12px 12px 12px 12px",
          },
          "&::placeholder": {
            paddingLeft: "4px",
          },
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: "bold",
          fontSize: 24,
          pb: 1,
          fontFamily: "'Montserrat', sans-serif",
          m: 0,
          p: 2,
        }}
      >
        {titleText}

        <IconButton
          aria-label={usesSpanish ? "cerrar" : "close"}
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ fontFamily: "'Montserrat', sans-serif" }}>
        <div>
          {!cancel_process && (
            <Typography
              variant="body1"
              mb={1}
              sx={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              {error}
            </Typography>
          )}

          {cancel_process && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "inherit",
                width: "100%",
              }}
            >
              <BounceLoader />
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}